import WizardReadMe from "@kiwicom/orbit-components/src/Wizard/README.md";
import * as React from 'react';
export default {
  WizardReadMe,
  React
};